import { render } from "./MultiAreaStackChart.vue?vue&type=template&id=f500dca0&scoped=true"
import script from "./MultiAreaStackChart.vue?vue&type=script&lang=js"
export * from "./MultiAreaStackChart.vue?vue&type=script&lang=js"

import "./MultiAreaStackChart.vue?vue&type=style&index=0&id=f500dca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f500dca0"]])

export default __exports__